import { takeLatest, call, put } from 'redux-saga/effects';
import * as passwordHintsActions from 'redux/ducks/personalInformation/passwordHintDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';
import memberAdminApi from 'api/employee/memberAdminApi';
import mailApi from 'api/others/mailApi';

export function* getPwdHintList() {
  try {
    const response = yield call(memberAdminApi.getPwdHintList);
    yield put(passwordHintsActions.getPwdHintListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}
export function* modifyPwdHintList({ payload }) {
  try {
    const response = yield call(memberAdminApi.modifyPwdHintList, payload);
    yield put(passwordHintsActions.modifyPwdHintListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getMailDomainList() {
  try {
    const response = yield call(mailApi.getPolicyInternalDomainList);
    yield put(passwordHintsActions.getMailDomainListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* passwordHintSaga() {
  yield takeLatest(passwordHintsActions.getPwdHintList, getPwdHintList);
  yield takeLatest(passwordHintsActions.modifyPwdHintList, modifyPwdHintList);
  yield takeLatest(passwordHintsActions.getMailDomainList, getMailDomainList);
}
